const fr = {
    enter_code: "ID de session",
    connect: "Relier",
    check_your_internet_connection: "Vérifiez votre connection internet.",
    network_error: "Erreur réseau",
    server_error: "erreur du serveur",
    check_server_connection: "Erreur Interne du Serveur",
    downtime: "Down Time",
    server_is_currently_facing_downtime: "Server est actuellement confronté à des temps d'arrêt",
    show_what_you_see: "Montrez ce que vous voyez",
    by_joining_i_confirm_that_i_have_read_and_understand_the: "Je confirme avoir lu et accepté la politique de confidentialité.",
    privacy_policy: "Politique de confidentialité",
    invalid_code: "ID de session non valide",
    code_should_be_of_nine_digits: "L'ID de session doit être composé de 9 chiffres",
    blitzz: "Blitzz",
    please_enter_your_name: "S'il vous plaît entrez votre nom",
    maximum_value_is_30: "Nom doit être inférieur à 30 caractères.",
    please_enter_meeting_id: "S'il vous plaît entrer votre code",
    please_try_again: "Veuillez réessayer.",
    no_one_is_sharing_video: "Personne ne partage vidéo.",
    retry: "Réessayez",
    reconnect: "Re-Connecter",
    left_the_conversation: "quitté la conversation",
    enabled_the_audio: "permis à l'audio",
    disabled_the_audio: "désactivé l'audio",
    enabled_the_video: "permis à la vidéo",
    disabled_the_video: "désactivé la vidéo",
    failed_to_join_room: "Impossible de rejoindre la chambre",
    alert: "Alerte",
    override_video_sharing_message: "Voulez-vous mettre fin à la part actuelle de l'écran et commencer à partager votre vidéo?",
    override_screen_sharing_message: "Voulez-vous mettre fin au partage d'écran en cours et commencer à partager votre écran?",
    override_video_sharing_with_screen_capturing_message: "Voulez-vous mettre fin à la vidéo en cours et commencer à partager votre écran?",
    override_screen_sharing_with_video_sharing_message: "Voulez-vous mettre fin à la part actuelle de l'écran et commencer à partager votre vidéo?",
    yes: "Oui",
    cancel: "Annuler",
    joined_the_call: "rejoint l'appel",
    waiting_for_other_members_to_join_the_call: "En attendant d'autres membres à se joindre à l'appel",
    warning: "Attention",
    camera_permission_disabled: "Impossible d'accéder à la caméra.",
    microphone_permission_disabled: "Impossible d'accéder au microphone.",
    location_permission_disabled: "Impossible d'accéder à l'emplacement.",
    storage_permission_disabled: "Impossible d'accéder au stockage",
    permission_error_message_camera: "S'il vous plaît activer l'appareil photo de réglages de l'appareil.",
    permission_error_message_microphone: "S'il vous plaît activer le microphone de réglages de l'appareil.",
    permission_location_error_message: "S'il vous plaît permettre à l'emplacement de réglages de l'appareil.",
    permission_storage_error_message: "S'il vous plaît permettre le stockage de paramètres de l'appareil.",
    give_permission: "Donner la permission",
    please_wait_for_five_seconds_to_take_screenshot: "S'il vous plaît attendre 5 secondes pour prendre une autre photo",
    please_wait_for: "Attendez s'il vous plaît",
    seconds_to_take_screen_shot: "secondes pour prendre une autre photo.",
    second_to_take_screen_shot: "seconde pour prendre une autre photo.",
    invalid_information_received_from_server: "Des informations incorrectes reçues du serveur.",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet:
        "Impossible de partager la vidéo comme personne d'autre n'a encore rejoint la conversation",
    successfully_uploaded: "avec succès téléchargé",
    disconnected: "Débranché",
    call_ended_as_no_one_else_had_joined_the_call: "Disconnected comme personne d'autre rejoint.",
    application_update_required: "mise à jour de l'application requise",
    update_required_message: "On dirait que vous êtes sur une ancienne version de l'application, s'il vous plaît mettre à jour de l'App Store.",
    update: "Mettre à jour",
    image_marking_started: "Image de marquage a commencé",
    image_marking_stopped: "Image de marquage arrêté",
    settings: "Réglages",
    camera_permission_rationale: "Nous devons avoir accès à votre appareil photo. S'il vous plaît donner la permission de la caméra",
    microphone_permission_rationale: "Nous avons besoin d'un accès à votre micro. S'il vous plaît donner la permission du microphone",
    location_permission_rationale: "Nous avons besoin d'un accès à votre emplacement. S'il vous plaît donner la permission de l'emplacement",
    storage_permission_rationale: "Nous devons avoir accès à votre stockage. S'il vous plaît donner la permission de stockage",
    call_between_two_customers: "L'agent n'a pas adhéré, s'il vous plaît réessayer à nouveau dans quelque temps.",
    media_projection_permission_needed_for_screen_sharing: "l'autorisation de projection de médias nécessaire pour le partage d'écran.",
    poor_network_connection: "Attention! mauvaise connexion réseau",
    you_are_the_only_person_in_the_call: "Vous êtes la seule personne dans l'appel",
    image_has_been_captured_and_started_uploading: "L'image a été capturé et mis en ligne de",
    version: "Version",
    please_enter_the_code_provided_to_you: "S'il vous plaît entrer le code fourni pour vous.",
    start_screen_share: "Partager l'écran",
    stop_screen_share: "Arrêter le partage",
    flip_camera: "Caméra flip",
    take_photo: "Prendre une photo",
    flash_off: "Flash désactivé",
    flash_on: "Flash activé",
    start_markup: "Markup Démarrer",
    stop_markup: "arrêt de balisage",
    speaker_off: "Président OFF",
    speaker_on: "Président ON",
    more: "Plus",
    close: "Fermer",
    video_off: "vidéo OFF",
    video_on: "vidéo ON",
    start_video: "Démarrer la vidéo",
    stop_video: "Arrêter la vidéo",
    disconnect: "couper",
    mute: "Muet",
    muted: "Activer le muet",
    powered_by_blitzz: "Alimenté par Blitzz",
    connecting_your_call: "Lié. En attente d'autres participants.",
    connected: "Connecté",
    pin_is_of_nine_digit: "La broche doit être de 9 chiffres",
    preparing_image_for_markup: "Préparation de l'image pour le balisage ...",
    clear_markup_confirmation: "Image claire Majorations de tous les utilisateurs?",
    clear_markup: "balisage clair",
    clear: "Clair",
    close_markup: "Markup Fermer",
    end_markup_confirmation: "Êtes-vous sûr de vouloir fermer le balisage?",
    end: "Fin",
    agent_has_ended_markup_cannot_continue_without_agent: "Agent a terminé le balisage. Ne peut pas continuer sans agent de balisage",
    joining_image_markup: "Chargement image pour le balisage ...",
    cleared_markup: "Majorations Image défrichées pour tous les utilisateurs.",
    capturing_photo: "Capture photo ...",
    uploading: "Téléchargement",
    image: "image",
    image_ready_for_markup: "Image prête à baliser.",
    override_video: "Cela arrêtera la vidéo des autres. Voulez-vous continuer?",
    override_screen_share: "Cela arrêtera autre partage d'écran. Voulez-vous continuer?",
    started_screen_share: "Commencé Screenshare.",
    stopped_screen_share: "Nous nous sommes arrêtés Screenshare.",
    clear_all: "Tout effacer",
    start_new_call_popup: "Démarrez nouvel appel avec le CODE",
    group_call_limit_reached: "limite d'appel du Groupe atteint",
    contact_admin_to_increase_participant_limit: "Veuillez attendre que tout autre participant se déconnecte, puis réessayez.",
    call_is_being_connected: "Appel est connecté, s'il vous plaît réessayer plus tard.",
    show_recording_for_training_purpose: "Cette séance est en cours d'enregistrement.",
    you_are_sharing_the_screen: "Vous partagez l'écran",
    location_colon: "Emplacement:",
    date_colon: "Date:",
    image_for_markup_has_been_downloaded: "Image pour le balisage a été téléchargé",
    dismiss: "Rejeter",
    google_play_service_is_not_up_to_date: "service de jeu Google pas mis à jour",
    rec: "Rec",
    you_are_offline: "Tu es hors ligne.",
    markup: "Balisage",
    exit: "Sortie",
    video_unsupported: "vidéo non pris en charge",
    please_open_this_link_in_safari: "S'il vous plaît ouvrir ce lien dans Safari.",
    you_are_not_able_to_see_this_video: "Vous n'êtes pas en mesure de voir cette vidéo.",
    only_number_Allowed: "Seuls les chiffres sont autorisés.",
    permission_warning: "Avertissement d'autorisation",
    unable_to_join_call_please_try_after_sometime: "Impossible de se joindre à l'appel. S'il vous plaît essayer après un certain temps",
    share_live_video: "Partagez votre vidéo en direct?",
    share_your_screen: "Partagez votre écran?",
    unable_access_flash: "Impossible d'accéder à Flash Light.",
    camera_unavailable_try_again: "L'appareil photo est disponible, essayez à nouveau.",
    unable_download_image_tomarkup: "Impossible de télécharger l'image pour traitement, veuillez réessayer.",
    try_again: "Réessayer",
    markup_screen_appear_shortly: "écran de balisage apparaîtra sous peu ...",
    confirm: "Confirmer",
    start: "Début",
    could_not_find_endpoint: "Impossible de trouver le point final du serveur.",
    please_wait: "S'il vous plaît, attendez...",
    done: "Terminé",
    ok: "D'accord",
    please_try_again_with_valid_agent_id: "S'il vous plaît essayer à nouveau avec l'ID d'agent valide.",
    meeting_code_not_associated_with_agent: "L'ID de session n'est pas associé à cet ID d'agent.",
    powered_by: "Alimenté par",
    failure: "Échec",
    code: "ID de session",
    start_new_call_question: "Démarrez nouvel appel?",
    stop_sharing: "arrêter le partage",
    reconnecting_call: "appel ... Reconnexion",
    unable_to_access_mircrophone_or_camera: "Impossible d'accéder à votre micro ou un appareil photo.",
    be_sure_to_allow_access_in_browser: "Assurez-vous d'autoriser l'accès à vos paramètres de votre navigateur.",
    make_sure_you_have_microphone_camera_attached: "Assurez-vous que vous avez fixé la caméra ou le microphone.",
    location_blocked_by_user: "Localisation bloquées par l'utilisateur",
    user_has_joined_the_call: "Un utilisateur a rejoint l'appel",
    are_you_sure_you_want_to_close_window: "Etes-vous sûr de vouloir fermer cette fenêtre?",
    reset_guide: "Guide Réinitialiser",
    open_in_google_maps: "Ouvrir dans Google Maps",
    location_image_upload_failed: "Localisation l'image téléchargement a échoué",
    uploading_image: "Transfert de l'image",
    upload_failed: "téléchargement échoué",
    markup_is_in_progress: "Markup est InProgress ...",
    select_language: "Choisir la langue",
    checking_for_extension: "Vérification de l'extension ...",
    start_incognito_mode_from_blitzz_screen_share_ext:
        "Pour commencer la part de l'écran en mode navigation privée vous devez commencer le mode incognito de Blitzz - Extension de partage d'écran de votre navigateur.",
    click_on: "Cliquer sur",
    customize_and_control_menu: "Personnaliser et contrôler le menu",
    more_tools: "autres outils",
    extensions: "extensions",
    click_on_detail: "Cliquez sur le détail (Blitzz)",
    allow_in_incognito: "Autoriser en mode navigation privée.",
    screen_share: "Partage d'écran",
    stop_share: "arrêt Partager",
    save: "sauvegarder",
    cancel_initcap: "Annuler",
    yes_initcap: "Oui",
    message_title: "Message",
    device_not_compatible: "Désolé, cet appareil n'est pas compatible.",
    please_download_our_app: "S'il vous plaît télécharger notre application pour continuer.",
    download_app: "télécharger App",
    this_browser_is_not_supported: "Ce navigateur est actuellement pas pris en charge.",
    open_in_chrome_or_install_mobile_app:
        "Veuillez copier et coller ce lien dans la dernière version de Google Chrome ou installer notre application mobile et réessayer.",
    open_in_safari_or_install_mobile_app:
        "Veuillez copier et coller ce lien dans la dernière version du navigateur Safari ou installer notre application mobile et réessayer.",
    open_in_chrome_and_try_again: "S'il vous plaît ouvrir ce lien dans la dernière version de Google Chrome et essayez à nouveau.",
    okay_initcap: "d'accord",
    would_you_like_to_install_app_or_continue_browser:
        "Voulez-vous installer notre application pour joindre à la réunion ou Continuer avec le navigateur?",
    continue_initcap: "Continuer",
    webview_limited_support_message:
        "Pour une expérience optimale, veuillez ouvrir ce fichier dans le navigateur Chrome ou votre navigateur par défaut.",
    continue_anyway: "Continuez quand même",
    open_in_browser: "Ouvrir dans le navigateur",
    link_copied_open_in_browser: "Lien copié ! Si votre navigateur ne l'ouvre pas, collez le lien dans Chrome.",
    add_blitzz_extension_to_screen_share: "Ajouter l'extension à Blitzz partage d'écran",
    add_to_chrome_and_confirm: "« Ajouter à Chrome et confirmer »",
    add_extension: "Ajouter une extension",
    permission_error_message_camera_browser: "S'il vous plaît activer l'appareil photo à partir des paramètres du navigateur.",
    camera_not_found: "Appareil photo introuvable",
    enable_camera_and_reconnect_call: "Vous devez activer votre appareil photo, recharger la page et reconnecter l'appel.",
    permission_error_message_microphone_browser: "S'il vous plaît activer le microphone de paramètres du navigateur.",
    permission_error_message_location_browser: "Veuillez activer l'emplacement à partir des paramètres du navigateur.",
    microphone_not_found: "Microphone not found",
    enable_microphone_and_reconnect_call: "Vous devez activer votre microphone, recharger la page et reconnecter l'appel.",
    download_failed: "Échec du téléchargement",
    continue_markup: "continuer Markup",
    save_and_exit: "Enregistrer et Quitter Markup",
    exit_markup: "Marquage de sortie",
    you_are_recording_the_conversation: "Vous êtes maintenant l'enregistrement de la conversation.",
    make_sure_participant_know_they_are_being_recorded: "Assurez-vous que les participants savent qu'ils sont en cours d'enregistrement.",
    you_can_download_recordings_later: "Vous pouvez télécharger le fichier enregistré par la suite.",
    share_without_joining_session_lanuch_showme_enter_code:
        "Impossible d'écran sans se joindre à l'action d'une session ShowMe. S'il vous plaît lancer ShowMe par Blitzz, et entrez le code fourni pour vous.",
    call_limit_reach_contact_Admin_to_increase_limit:
        "limite d'appel du Groupe atteint. S'il vous plaît contacter votre administrateur pour augmenter la limite de participant ou d'attendre un membre de quitter la séance.",
    other_user_trying_share_screen_Video: "Un autre utilisateur tente de partager l'écran ou vidéo",
    call_has_ended: "Appel a pris fin",
    would_you_like_to_save_image: "Voulez-vous enregistrer l'image?",
    audio_unsupported: "audio non pris en charge",
    please_install_our_app_to_continue: "S'il vous plaît installer notre application pour continuer.",
    unable_to_play_remote_audio: "Impossible de lire l'audio à distance.",
    unable_to_playback_audio: "Impossible de lire l'audio.",
    unable_to_play_video: "Impossible de lire la vidéo.",
    unable_to_playback_video: "Impossible de lire la vidéo.",
    okay_cap: "D'accord",
    pre_call_test: "Test de pré-appel",
    language: "Langue",
    reset: "Réinitialiser",
    zoom_in: "Agrandir",
    zoom_out: "Dézoomer",
    headset: "Casque",
    bluetooth: "Bluetooth",
    live_pointer_enabled_message: "Commencé live pointeur. Vous pouvez déplacer le pointeur en faisant glisser.",
    speaker: "Orateur",
    live_pointer_disabled_message: "Arrêt du pointeur en direct",
    pointer: "Aiguille",
    network_quality: "Qualité du réseau",
    participant: "Participant",
    you: "(Vous)",
    reconnecting: "Reconnexion",
    very_bad: "Très mauvais",
    bad: "Mal",
    poor: "Pauvre",
    good: "Bien",
    excellent: "Excellent",
    loc: "Loc",
    expand: "Développer",
    collapse: "Effondrer",
    network: "Réseau",
    ocr_inprogress: "OCR est en cours ...",
    select_area_extract_text: "Sélectionner une zone pour extraire du texte",
    text_copied: "Texte copié",
    extract_text_from_image: "Extraire le texte de l'image ...",
    not_extract_text_from_image: "Impossible d'extraire le texte de l'image.",
    try_again_clear_image_or_reselect_region: "Veuillez réessayer avec une image claire ou resélectionnez votre région d'extraction.",
    error: "Erreur",
    occured_while_receiving_doc: "s'est produite lors de la réception du document.",
    return_to_video: "Retour à la vidéo",
    save_entire_image: "Enregistrer tout",
    save_cropped_image: "Enregistrer le recadrage",
    text_copied_to_clipboard: "Cliquez pour copier",
    extract_text: "Extraire le texte",
    stop_pointer: "Arrêter le pointeur",
    do_not_rotate_the_phone_live_pointer_message:
        "Pour une meilleure expérience de visualisation, veuillez ne pas faire pivoter l'appareil lorsque le pointeur en direct est activé.",
    got_it_btn: "Je l'ai!",
    speed_test: "Test de rapidité",
    duration: "Durée",
    preparing_image_for_OCR: "Préparation de l'image pour le traitement de texte…",
    agent_extract_text_from_image: "Veuillez patienter, l'agent extrait le texte de l'image capturée.",
    unable_download_image_to_ocr: "Impossible de télécharger l'image pour traitement, veuillez réessayer.",
    selected_area_is_small: "La zone sélectionnée est trop petite.",
    please_select_large_area: "veuillez sélectionner une grande zone d'image.",
    zoom_level: "Le niveau de zoom",
    do_not_rotate_the_phone_markup_message:
        "Pour une meilleure expérience visuelle, veuillez ne pas faire pivoter le périphérique tant que le marquage est activé.",
    capturing: "Capture ...",
    upload_completed: "Téléchargement terminé",
    network_quality_not_available: "Qualité du réseau non disponible",
    not_able_to_see_your_stream: "ne sera pas en mesure de voir votre flux.",
    device_not_supported: "Dispositif non pris en charge.",
    video_settings_need_to_be_configured_by_admin_web:
        "Les paramètres vidéo doivent être configurés par votre administrateur pour prendre en charge ce périphérique. Veuillez contacter l'administrateur de votre entreprise ou envoyer un courrier électronique à",
    contact: "Contact",
    video_paused_by_agent: "Vidéo mise en pause par l'agent",
    not_shared: "Non partage",
    network_type: "Type de réseau",
    image_thumb_caption: "Image:",
    saved_images: "Images sauvegardées",
    update_your_browser_to_share_your_screen: "Mettez à jour votre navigateur vers la dernière version pour partager votre écran",
    try_these_option_to_have_better_experience: "Essayez l'une de ces options pour une meilleure expérience.",
    some_features_are_not_supported_in_this_browser: "Certaines fonctionnalités ne sont pas prises en charge dans ce navigateur.",
    unsupported_browser: "Navigateur non supporté",
    permission_message_for_screenshare:
        "Les autorisations d'accès à la zone d'écran ont été refusées ou votre instance de navigateur actuelle ne dispose pas des autorisations d'accès au partage d'écran.",
    go_to_system_preferences: "Accéder aux préférences système",
    security_privacy: "Sécurité et confidentialité",
    select_privacy_tab: "Sélectionnez l'onglet Confidentialité",
    screen_recording: "Enregistrement d'écran",
    select_your_browser: "Sélectionnez votre navigateur",
    use_chrome_to_share_your_screen: "Utilisez le navigateur Chrome ou Firefox pour partager votre écran",
    there_was_an_error_trying_to_share_your_video: "Une erreur s'est produite lors de la tentative de partage de votre vidéo.",
    please_stop_video_and_start_video_again_to_resume: "Veuillez arrêter la vidéo et recommencer la vidéo pour reprendre.",
    decline: "Refuser",
    agree: "Accepter",
    click_the_padlock: "Cliquez sur le cadenas",
    to_the_left_of_a_web_page_address: "à gauche de la barre d'adresse.",
    clear_blocked_permission_for_share_the_screen: "Effacez toutes les autorisations de partage d'écran bloquées dans la section des autorisations.",
    tips_colon: "Conseils:",
    your_internet_connection_is_unstable: "Votre connexion Internet est instable",
    participants_connection_unstable: "La connexion Internet du participant <participantNum> est instable",
    enter_text_here: "Entrez le texte ici",
    text: "Texte",
    rect: "Rect",
    draw: "Dessiner",
    try_our_mobile_app: "Ouvrir dans l'application",
    still_facing_issue_connect_mobile_app: "Si vous rencontrez toujours un problème, connectez-vous à l'aide de notre application mobile.",
    open_in_app: "Ouvrir dans l'application",
    enable_microphone_from_browser_settings: "Activez le microphone dans les paramètres du navigateur.",
    enable_camera_from_browser_settings: "Activez l'appareil photo à partir des paramètres du navigateur.",
    unable_to_access_microphone: "Impossible d'accéder au microphone",
    participants_title: "Les participants",
    bookmarks_title: "Signets",
    search_or_add_new_bookmark: "Rechercher ou ajouter un nouveau signet",
    create_new_bookmark: "Créer un nouveau signet",
    press_enter_or_click_on_create_new_bookmark: "Appuyez sur Entrée ou cliquez sur Créer un nouveau signet pour ajouter un nouveau signet",
    tap_retry_to_load: "Appuyez sur Réessayer pour charger",
    bookmark_saved_with_image: "Signet enregistré avec image.",
    bookmark_saved: "Signet enregistré.",
    bookmark_added: "Signet ajouté.",
    failed_to_bookmark_please_try_again: "Impossible de créer un signet. Veuillez réessayer.",
    special_characters_are_not_allowed: "Les caractères spéciaux ne sont pas autorisés.",
    home_screen: "Écran d'accueil",
    privacy_policy_popup_text_description:
        "Je comprends et accepte đutiliser volontairement mon appareil photo pour partager une vue de mon environnement afin de résoudre le ou les problèmes techniques. Je comprends qu'aucun enregistrement ne sera effectué ou conservé. Je peux désactiver la fonction de partage à tout moment. Je ne pointerai pas la caméra vers des zones, des individus ou des objets dont je ne souhaite pas partager l'image. Je confirme également avoir lu et accepté la politique de confidentialité.",
    audio_issue_ios: "Problème audio?",
    toggle_mic_icon_guest_msg: "Basculez l'icône rouge du microphone / de la caméra ci-dessus ou utilisez le son des appels téléphoniques. (PSTN)",
    toggle_mic_icon_agent_msg:
        "Demander à l'utilisateur iOS de basculer l'icône de microphone / caméra rouge ci-dessus ou d'utiliser le son de l'appel téléphonique. (PSTN)",
    audio_ios_msg_read_more: "Lire la suite",
    error_occured_in_processing_the_request: "Une erreur s'est produite lors du traitement de la demande. Veuillez réessayer.",
    markup_ocr_upload_timeout: "Prenant plus de temps que d'habitude.",
    cancel_markup: "Annuler le balisage",
    markup_cancelled: "Annulation annulée",
    cancel_ocr: "Annuler l'extraction du texte",
    ocr_cancelled: "Extraire le texte annulé",
    click_here: "Cliquez ici",
    to_return_to_video_and_try_again: "pour revenir à la vidéo et réessayer.",
    test_connection: "Tester la connexion",
    markup_exit: "Markup arrêté",
    ocr_exit: "arrêté Extraire le texte",
    camera: "Caméra",
    camera_blocked: "Caméra bloquée",
    microphone: "Microphone",
    microphone_blocked: "Microphone bloqué",
    speakers: "Haut-parleurs",
    speakers_blocked: "Haut-parleurs bloqués",
    grant_permission: "Donner la permission",
    play_test_sound: "Lire le son de test",
    call_settings: "Paramètres d'appel",
    allow_access_to_camera: "Autorisez l'accès à votre caméra.",
    allow_access_to_mic: "Autorisez l'accès à votre microphone.",
    default_label: "Défaut",
    do_not_rotate_the_phone_OCR_message:
        "Pour une meilleure expérience de visionnement, veuillez ne pas faire pivoter l'appareil lorsque l'extraction de texte est activée.",
    browser_not_supported: "Navigateur non pris en charge",
    your_browser_not_support_video: "Votre navigateur ne prend pas en charge les appels vidéo.",
    open_link_in_google_samsung_browser:
        "Veuillez copier et coller ce lien dans la dernière version de Google Chrome ou du navigateur Internet Samsung.",
    open_link_in_safari_browser: "Veuillez copier et coller ce lien dans la dernière version du navigateur Safari.",
    copy_link: "Copier le lien",
    copy_code: "Copier le code",
    session_code_copy: "ID de session copié dans le presse-papiers.",
    meeting_code_lable: "Code de réunion",
    add_participant_lable: "Ajouter un participant",
    send_this_link_to_guest: "Envoyez ce lien à l'invité",
    send_an_email: "envoyer un e-mail",
    or_label: "ou",
    remote_mic_cam_error: "Le microphone / la caméra du participant distant a une erreur.",
    device_not_supported_or_permi_block: "Soit leur appareil n'est pas pris en charge, soit ils ont des autorisations bloquées.",
    remote_participant: "Participant à distance",
    microphone_unmuted: "Microphone non muet",
    microphone_muted: "Microphone désactivé",
    camera_on: "Caméra allumée",
    camera_off: "Caméra éteinte",
    error_label: "Erreur",
    cannot_start_video: "Impossible de démarrer la vidéo",
    failed_to_start_video_camera: "Impossible de démarrer la caméra vidéo.",
    please_select_another_camera_from_call_settings: "Veuillez sélectionner une autre caméra vidéo dans les paramètres d'appel.",
    please_select_another_video_camera: "Veuillez sélectionner une autre caméra vidéo.",
    chat: "Bavarder",
    chat_info:
        "Les messages de chat sont visibles par tous les participants à l'appel. L'historique des chats disparaîtra définitivement lorsque vous vous déconnecterez, par conception.",
    chat_input_placeholder: "Tapez un message",
    participant_connected: "<participantCount> participant (s) connecté (s)",
    click_to_share_invite: "Cliquez pour partager l'invitation",
    remote_flashlight_not_supported_on_guest_device_or_not_ready:
        "La lampe de poche à distance n'est pas prise en charge sur l'appareil invité ou n'est pas prête",
    pin_a_video_tile_above_to_use_this_feature: "Épinglez une vignette vidéo ci-dessus pour utiliser cette fonctionnalité",
    pin_video_for_all_participants: "Épingler la vidéo pour tous les participants",
    return_to_gallery_view: "Revenir à la vue de la galerie",
    override_own_screen_share: "Votre partage d'écran sera interrompu. Voulez-vous continuer?",
    override_own_video: "Votre vidéo sera arrêtée. Voulez-vous continuer?",
    blur: "Brouiller",
    mask_lable: "Masque",
    view_text: "Vue",
    arrow: "La Flèche",
    recording_stopped: "Enregistrement arrêté",
    error_recording_please_try_again: "Erreur lors de l'enregistrement, veuillez réessayer",
    error_recording_wait_or_disconnect_call:
        "Erreur d'enregistrement. Veuillez attendre que l'hôte arrête l'enregistrement, ou vous pouvez vous déconnecter et vous réinscrire plus tard.",
    wait_for_recording: "Veuillez patienter pendant que nous commençons l'enregistrement ...",
    max_participant_limit_for_recording:
        "Max. limite de participants atteinte pendant l'enregistrement. Veuillez attendre que l'hôte arrête l'enregistrement, ou vous pouvez vous déconnecter et vous réinscrire plus tard.",
    error_recording_all_participants: "Erreur lors de l'enregistrement de tous les participants.",
    please_stop_and_restart_recording: "Veuillez arrêter et redémarrer l'enregistrement.",
    some_participants_will_not_be_recorded: "Certains participants ne seront pas enregistrés.",
    participant_limit_reached: "Limite de participants atteinte.",
    your_account_has_4_participant_limit_while_recording: "Votre compte a une limite de 4 participants pendant l'enregistrement.",
    disconnect_call: "Déconnecter l'appel",
    record_title: "Record",
    stop_recording_btn: "Arrête d'enregistrer",
    back_to: "Retour à",
    cam_per_denied_msg: "L'un de vos participants a peut-être bloqué l'accès à la caméra sur son appareil. Pour les guider, veuillez consulter",
    mic_per_denied_msg: "L'un de vos participants a peut-être bloqué l'accès au microphone sur son appareil. Pour les guider, veuillez consulter",
    cam_mic_per_denied_msg:
        "L'un de vos participants a peut-être bloqué l'accès à la caméra et au microphone sur son appareil. Pour les guider, veuillez consulter",
    per_denied_common_msg: "pour obtenir des conseils rapides pour réinitialiser les autorisations du navigateur.",
    your_camera_block: "Votre caméra est bloquée",
    your_microphone_block: "Votre microphone est bloqué",
    your_location_block: "Votre position est bloquée",
    we_cannot_access_your_camera: "Nous ne pouvons pas accéder à votre caméra.",
    we_cannot_access_your_microphone: "Nous ne pouvons pas accéder à votre microphone.",
    we_cannot_access_your_location: "Nous ne pouvons pas accéder à votre position.",
    go_to_browser_settings: "Pour donner accès, allez dans les paramètres de votre navigateur puis cliquez ici pour recharger la page.",
    still_facing_issue: "Toujours confronté à un problème?",
    try_the: "Essaie le",
    mobile_app: "application mobile",
    view_help_article: "Afficher l'article d'aide",
    enable_or_attach_camera_and_reconnect_call: "Vous devez activer ou connecter la caméra, recharger la page et reconnecter l'appel.",
    enable_or_attach_microphone_and_reconnect_call: "Vous devez activer ou connecter le microphone, recharger la page et reconnecter l'appel.",
    start_rec_label: "Démarrez Rec.",
    stop_rec_label: "Arrêtez Rec.",
    start_recording_tooltip_label: "Commencer l'enregistrement",
    click_here_label: "cliquez ici",
    cam_per_denied_title: "Caméra du participant distant bloquée",
    mic_per_denied_title: "Microphone du participant distant bloqué",
    cam_mic_per_denied_title: "Caméra et microphone du participant distant bloqués",
    these_instructions: "ces instructions",
    Whisper_on: "Murmure sur",
    Whisper_off: "Whisper Off",
    enable_whisper_tooltip_label: "Activer le chuchotement pour parler avec l'hôte",
    host_can_hear_you_now: "L'hôte peut vous entendre maintenant",
    mediate_lable: "Médiat",
    join_call_as_participant: "Rejoindre l'appel en tant que participant",
    observer_lable: "Observateur",
    silent_observer_connect_alert_popup: "Connecté en tant qu'observateur. Votre micro et votre caméra sont coupés.",
    click_mediate_if_you_would_like_to_join_as_a_participant: 'Cliquez sur "Médiation" si vous souhaitez participer.',
    guest_lable: "Guest",
    Silent_observer_lable: "Observateur silencieux",
    invite_participant_tooltip_lable:
        "Le microphone et la caméra seront désactivés pour Silent Observer et ne seront pas visibles par les participants invités.",
    send_link_silent_observer: "Envoyez ce lien à l'observateur silencieux.",
    join_as_mediator_title: "Rejoindre en tant que médiateur?",
    join_as_mediator_popup_description:
        "Voulez-vous vraiment participer à l'appel en tant que participant? Cliquez sur Confirmer ci-dessous, puis sur Se connecter dans l'écran suivant pour rejoindre en tant que participant (médiateur).",
    from_participant: "Du participant",
    download_key: "Télécharger",
    download_not_supported_text: "Le téléchargement n'est pas pris en charge sur votre appareil.",
    undo: "Annuler",
    redo: "Refaire",
    color_label: "Couleur",
    overall_experience: "Expérience globale?",
    leave_comment: "Laisser un commentaire (facultatif)",
    sent: "Envoyé",
    send: "Envoyer",
    view_unavailable: "Vue indisponible",
    whisper_label: "Chuchotement",
    thanks: "Merci!",
    stop_recording_tooltip_label: "Revenez en mode galerie pour arrêter l'enregistrement.",
    save_image: "Enregistrer l'image",
    screenshare_mweb_text:
        "Le partage d'écran depuis votre appareil nécessite une application. Veuillez connecter cette session depuis l'application mobile.",
    disconnect_and_launchapp_btn: "Déconnecter et lancer l'application",
    device_battery_low: "Batterie de l'appareil faible",
    batteryinfo_tooltip: "Informations sur la batterie de l'appareil",
    notes_lable: "Remarques",
    new_note_lable: "Nouvelle note",
    only_visible_to_you: "Seulement visible par vous",
    empty_note: "Note vide",
    title_lable: "Titre",
    delete_lable: "Supprimer",
    delete_Note: "Supprimer la note",
    want_delete_this_note: "Voulez-vous vraiment supprimer cette note?",
    failed_delete_note: "Échec de la suppression de la note.",
    note_deleted_successfully: "Note supprimée",
    failed_edit_note: "Échec de la modification de la note.",
    note_edited_successfully: "Note mise à jour",
    failed_add_note: "Échec de l'ajout de la note.",
    note_added_successfully: "Note ajoutée",
    screenshare_mweb_title: "Téléchargement de l'application requis",
    screenshare_mweb_desc1: "Le partage d'écran depuis votre appareil nécessite une application.",
    screenshare_mweb_desc2: "pour télécharger l'application.",
    upcoming_event: "Événement à venir",
    scheduled_to_start_in: "Prévu pour commencer dans",
    please_wait_for_the_host_to_start_this_event: "Veuillez attendre que l'hôte démarre cet événement et réessayez.",
    image_deleted: "Image supprimée",
    failed_to_delete_image: "Échec de la suppression de l'image",
    are_you_sure_you_want_to_delete_image: "Êtes-vous sûr de vouloir supprimer définitivement cette image?",
    delete_image_title: "Supprimer l'image",
    location_image_thumb_caption: "Image d'emplacement",
    schedule_to_start_in_a_few_seconds: "Prévu pour démarrer dans quelques secondes.",
    edit_label: "Éditer",
    scan_code_lable: "Scan code",
    scan_code_result: "Résultat du scan code",
    extract_text_result: "Extraire le résultat du texte",
    scan_code_result_not_found: "Impossible de scanner le QRcode / Barcode à partir de l'image. Veuillez réessayer avec une image claire.",
    host_features_will_not_be_available_when_using_app:
        "Les fonctionnalités de l'hôte ne seront pas disponibles lors de l'utilisation de l'application.",
    note_colon: "Remarque:",
    leave_lable: "Partir",
    are_you_sure_you_want_to_leave_this_call: "Voulez-vous vraiment quitter cet appel?",
    supported_browser_versions: "Versions de navigateur prises en charge.",
    see: "Voir",
    has_sent_you_link_for_video_conference: "<company_name> vous a envoye un lien pour la conference video en direct.",
    join_the_session: "Rejoignez la session",
    other: "Autre",
    share_invitation_with_others: "Partager l'invitation à la session avec d'autres",
    copy_invitation: "Copier l'invitation à la session",
    copy_invitation_desc: "Copiez le texte d'invitation avec l'heure programmée et envoyez-le manuellement",
    copied: "Copié!",
    copy_session_code: "Copier l'ID de session",
    copy_link_to_share: "Copier le lien pour partager",
    reference: "Référence",
    session_invitation_copied: "Invitation à la session copiée dans le presse-papiers.",
    guest_url_copy: "URL d'invité copiée dans le Presse-papiers.",
    observer_url_copied: "URL d'observateur copiée dans le presse-papiers.",
    sms_sent_label: "SMS envoyé!",
    email_sent_label: "Email envoyé!",
    invite_sent_successfully: "Inviter envoyé avec succès",
    sms_label: "SMS",
    copy: "Copie",
    email: "Email",
    enter_valid_email: "Entrez l'adresse e-mail valide.",
    limit_exceeded: "Limite dépassée",
    enter_email_send: "Entrez un e-mail pour envoyer une invitation",
    send_invitaion_lable: "Envoyer une invitation",
    enter_mobile_number_lable: "Entrez le numéro de mobile",
    enter_valid_mobile: "Entrez un numéro de mobile valide.",
    new_email_address: "Adresse e-mail",
    mobile_number: "Numéro de portable",
    video_quality: "Qualité vidéo",
    low_bandwidth: "Bas débit",
    adaptive: "Adaptatif",
    high_quality: "Haute qualité",
    wait_for_the_call_to_start: "Attendez que l'appel commence",
    call_disconnected: "Appel déconnecté",
    dont_show_this_again: "Ne plus montrer ça",
    invite_participant_lable: "Inviter un participant",
    saved_label: "Enregistré!",
    show_stream: "Montrer",
    hide_stream: "Cacher",
    camera_permission_required_title: "Autorisation de la caméra requise",
    camera_permission_required_disc1:
        "Pour partager une vidéo en direct, veuillez activer l'autorisation de la caméra dans les paramètres de votre navigateur, puis",
    reload_page_disc: "pour recharger la page.",
    location_permission_required_title: "Autorisation de localisation requise",
    microphone_permission_required_title: "Autorisation du microphone requise",
    confirmation_lable: "Je peux confirmer que j'ai lu et j'accepte les",
    live_location: "Localisation en direct",
    no_one_shared_location: "Personne n'a partagé sa position",
    it_was_great_lable: "C'était super",
    not_so_great_lable: "Pas si bien",
    link_copied: "Lien copié",
    microphone_publication_description: "Microphone introuvable ou peut être utilisé par une autre application.",
    please_close_all_other_application: "Veuillez fermer toutes les autres applications susceptibles d'utiliser le microphone et réessayer.",
    app_to_share_your_device_screen: "Continuez cet appel dans l'application pour partager l'écran de votre appareil",
    launch_app: "Démarrer l'application",
    screen_share_requires_app: "Le partage d'écran nécessite une application.",
    only_takes_few_seconds: "Cela ne prend que quelques secondes.",
    download_app_from_app_store_and_then_return_page: "Téléchargez l'application depuis l'App Store, puis revenez sur cette page.",
    click_to_download_app: "Cliquez pour télécharger l'application",
    go_to_Step_2: "Si vous avez déjà téléchargé l'application, passez à l'étape 2",
    next_lable: "Suivant",
    rejoin_the_call_in_app: "Rejoindre l'appel dans l'application",
    step2_screen_share_description:
        "Après avoir téléchargé l'application, vous pouvez rejoindre cet appel dans l'application et sélectionner « Partage d'écran » pour partager votre écran mobile.",
    disconnect_the_call_in_browser: "Cela déconnectera l'appel dans le navigateur",
    back_btn_lable: "Dos",
    rejoin_call_in_app: "Rejoindre l'appel dans l'application",
    step_one: "Étape 1",
    step_two: "Étape 2",
    beta_release_tag_des1: "Cette fonctionnalité est actuellement en version Beta.",
    email_support_feedback: "Veuillez envoyer un courriel à support@blitzz.co pour partager vos commentaires.",
    would_you_like_to_exit_markup: "Souhaitez-vous quitter le balisage ?",
    current_position: "Position actuelle",
    start_point: "Point de départ",
    live_captions: "Sous-titres en direct",
    starting_label: "Départ...",
    live_captions_started: "Les sous-titres en direct ont commencé.",
    spoken_language_is_set_to_english: "La langue parlée est définie sur l'anglais.",
    click_to_open_more_information: "Cliquez pour ouvrir plus d'informations",
    open_in_safari_chrome_or_install_mobile_app:
        "Veuillez copier et coller ce lien dans la dernière version de Safari ou du navigateur Google Chrome ou installer notre application mobile et réessayer.",
    continue_without_name: "Continuer sans nom",
    enter_your_name: "Entrez votre nom",
    ignore: "Ignorer",
    screen_share_info:
        "Pour éviter un miroir à l'infini, ne partagez pas l'intégralité de votre écran ou de la fenêtre de votre navigateur. Partagez plutôt un onglet ou une fenêtre différente.",
    screen_share_to_everyone: "Vous partagez l'écran avec tout le monde",
    stop_share_screen: "Arrêter l'écran de partage",
    unable_to_start_the_video_please_download_the_app_to_continue:
        "Impossible de démarrer la vidéo, veuillez télécharger l'application pour continuer.",
    upload: "Télécharger",
    from_device: "Depuis l'appareil",
    from_camera: "De la caméra",
    upload_failed_files: "Échec du téléchargement des fichiers",
    uploaded_max_file: "Vous avez téléchargé le nombre maximum de fichiers autorisés.",
    upload_files: "Télécharger des fichiers",
    upload_limit_reached: "Limite de téléchargement atteinte",
    drop_for_upload_or_select: "Déposez ici pour télécharger, ou sélectionnez",
    upload_20_file: "Téléchargez jusqu'à 20 fichiers à la fois.",
    max_size_20MB: "Max. taille du fichier <fileSize> Mo.",
    cancel_upload: "Annuler le téléchargement",
    cancel_upload_alert: "Annuler le téléchargement ?",
    file_details_deleted: "Tous les détails ajoutés à vos fichiers seront supprimés.",
    uploaded_files: "Fichiers téléchargés",
    capture_image: "Capturer une image",
    participant_uploading_file_msg: "Veuillez patienter pendant que l'autre participant télécharge des fichiers.",
    previous: "Précédent",
    max_file_count: "Vous pouvez télécharger un maximum de fichiers <fileCount> à la fois.",
    removed_more_than_20MB_file: "Les fichiers dont la taille est supérieure à <fileSize> Mo sont supprimés.",
    uploading_files: "Téléchargement de fichier(s)",
    upload_failed_file_count: "Le téléchargement a échoué : les fichiers <numberOfFailedFiles> n'ont pas été téléchargés.",
    add_caption: "Ajouter une légende...",
    uploaded_files_of_a_maximum: "<successCount> fichier(s) téléchargé(s), d'un maximum <totalCount>",
    you_have_selected_the_maximum_number_of_files_allowed: "Vous avez sélectionné le nombre maximum de fichiers autorisés.",
    upload_max_count: "Téléchargez le(s) fichier(s) <remainingCount> maximum.",
    image_upload_msg: "Veuillez patienter pendant le téléchargement des images",
    finished_uploading: "Téléchargement terminé",
    upload_files_msg: "Télécharger des fichiers",
    uploading_dots: "Téléchargement…",
    loading_image_counter: "Chargement de l'image <counter> de <totalCount>",
    closing_tab: "Onglet de fermeture",
    close_tab: "Fermer l'onglet",
    return_to_home_screen: "Retour à l'écran d'accueil",
    session_code_expire_msg: "Ce lien a été fermé",
    view_call_logs: "Afficher les journaux d'appels",
    measurements: "Des mesures",
    copy_all: "Tout copier",
    measure: "Mesure",
    view_supported_device: "Afficher les appareils pris en charge",
    device_not_support_google_play_service:
        "L'appareil du participant ne prend pas en charge le service Google Play qui est requis pour les mesures 3D",
    device_not_compatible_for_measurement: "Appareil non compatible pour la mesure",
    device_required_update_google_play_service:
        "L'appareil du participant nécessite la mise à jour du service Google Play pour démarrer la mesure 3D.",
    device_required_google_play_service: "L'appareil du participant nécessite l'installation du service Google Play pour démarrer la mesure 3D",
    app_required_update_for_measurement: "Prise en charge de la mise à jour de l'application requise pour la mesure",
    app_required_for_measurement: "Application de support requise pour la mesure",
    preparing_ar_measurement: "Préparation de la vue pour la mesure...",
    measurement_copied_msg: "Mesures copiées dans le presse-papiers",
    ready_for_measurement: "Prêt pour la mesure",
    move_device_to_start: "Déplacer l'appareil pour démarrer",
    tacking_not_available: "Le suivi n'est pas disponible",
    camera_use_bu_another_app: "La caméra est utilisée par une autre application",
    more_light_required: "Plus de lumière nécessaire",
    move_further_away: "Éloignez-vous plus loin",
    slow_down: "Ralentir",
    measurement_cancelled: "Mesure annulée",
    app_required: "Cette fonctionnalité nécessite le téléchargement de l'application. <learnmore>",
    learn_more: "Apprendre encore plus",
    ar_measurement_description_step2:
        "Après avoir téléchargé l'application, vous pouvez rejoindre cet appel dans l'application et sélectionner \"Mesurer\" pour démarrer la mesure AR",
    ar_measurement_description_step1:
        "La fonction de mesure de la réalité augmentée vous permet de mesurer des objets en 3D et nécessite un téléchargement d'application",
    app_to_support_ar_measurement: "Continuez cet appel dans l'application pour prendre en charge la mesure AR",
    find_surface_to_measure: "Trouver une surface proche à mesurer",
    measurement_toast_note_to_guide_user: "Remarque : les mesures sont approximatives.",
    measurement_toast_msg_to_guide_user:
        "Pour de meilleurs résultats, utilisez Mesurer sur des objets bien définis situés entre 0,5 et 3 mètres (2 à 10 pieds) de votre téléphone.",
    having_audio_issue: "Vous avez un problème audio ?",
    remote_participant_voice_not_coming_description:
        "Il semble que vous rencontriez des difficultés pour entendre la voix d'un autre participant ou que vous rencontriez actuellement une sorte de problème audio.",
    workaround_action_for_remote_audio_not_coming: "<click_here> pour appliquer une solution de contournement rapide.",
    click_here_for_audio_label: "Cliquez ici",
    measurement_copyall_msg: "Mesure(s) copiée(s) dans le presse-papiers",
    armarkup_cancelled: "Balisage AR annulé",
    device_not_support_google_play_service_for_markup:
        "L'appareil du participant ne prend pas en charge le service Google Play qui est requis pour le balisage 3D",
    device_required_update_google_play_service_for_markup:
        "L'appareil du participant nécessite la mise à jour du service Google Play pour démarrer le balisage 3D.",
    device_required_google_play_service_for_markup:
        "L'appareil du participant nécessite l'installation du service Google Play pour démarrer 3D Markup",
    device_not_compatible_for_AR_Markup: "Appareil non compatible avec AR Markup",
    app_required_update_for_AR_Markup: "Prise en charge de la mise à jour de l'application requise pour AR Markup",
    app_required_for_AR_Markup: "Application de support requise pour le balisage AR",
    preparing_view_for_ar_markup: "Préparation de la vue pour le balisage AR...",
    AR_Markup_Lable: "Balisage AR",
    armarkup_toast_msg_to_guide_user:
        "Pour de meilleurs résultats, utilisez Markup sur des objets bien définis situés entre 0,5 et 3 mètres (2 à 10 pieds) de votre téléphone.",
    ar_live_streaming_ready_to_markup: "Diffusion en direct AR prête à être balisée.",
    ar_markups_cleared_for_all_users: "Marquages AR effacés pour tous les utilisateurs.",
    ar_live_streaming_marking_stopped: "Marquage de diffusion en direct AR arrêté",
    agent_has_ended_ar_markup_cannot_continue_without_agent: "L'agent a terminé le balisage AR. Impossible de poursuivre le balisage AR sans agent",
    ar_markup_cancelled: "Balisage AR annulé",
    ready_for_ar_markup: "Prêt pour le balisage AR",
    max_ar_arrow_limit_toast_message: "Limite de flèche atteinte, veuillez utiliser tout effacer pour en ajouter d'autres.",
    video_paused: "vidéo en pause",
    discard_label: "Jeter",
    discard_image_label: "Ignorer l'image",
    save_image_label: "Enregistrer l'image",
    go_room_call_limit_reached: "Limite d'appels Go Room atteinte",
    circle: "Cercle",
    arrow_with_text: "Flèche avec texte",
    add_shadow_and_stroke: "Ajouter une ombre et un trait",
    font_label: "Police de caractère:",
    file_type_not_supported: "Type(s) de fichier(s) non pris en charge",
    crt_acnt_enter_confirm_password: "",
    create_new_note_description: "Veuillez cliquer sur le bouton Nouvelle note ci-dessous pour commencer à prendre des notes.",
    remote_user_stream_interrupted: "Flux d'utilisateurs distants interrompu",
    audio_disabled_by_admin: "Audio désactivé par l'administrateur",
    audio_disabled: "Audio désactivé",
    dont_show_again: "Ne plus afficher",
    whatsapp_sent_label: "Invitation WhatsApp envoyée !",
    whatsapp_label: "WhatsApp",
    having_an_issue_with_joining_the_call: "Vous rencontrez un problème pour rejoindre l’appel?",
    to_perform_network_check: "pour effectuer une vérification du réseau",
    you_were_removed_from_the_call_by_the_host: "Vous avez été retiré de l'appel par l'hôte",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now:
        "Vous avez été retiré de l'appel par l'hôte et vous ne pouvez plus le rejoindre maintenant.",
    host_removed_you_from_the_call: "L'hôte vous a retiré de l'appel.",
    unable_to_join_the_call: "Impossible de rejoindre l'appel",
    host_muted_your_microphone: "L'hôte a coupé votre microphone.",
    unmute_your_microphone: "Désactiver votre microphone",
    host_invites_you_to_speak_unmute_your_microphone_when_ready: "L'hôte vous invite à parler. Désactivez votre microphone lorsque vous êtes prêt.",
    got_it: "J'ai compris",
    unmute_mic: "Activer le micro",
    host_turned_off_your_camera: "L'hôte a éteint votre caméra.",
    turn_your_camera_on: "Allumez votre appareil photo",
    host_invites_you_to_turn_your_camera_on: "L'hôte vous invite à allumer votre caméra.",
    turn_camera_on: "Allumer la caméra",
    start_sharing_your_screen: "Commencez à partager votre écran",
    host_invites_you_to_share_your_screen: "L'hôte vous invite à partager votre écran.",
    share_screen: "Partager l'écran",
    remove_all: "Supprimer tout",
    remove: "Retirer",
    end_call: "Mettre fin à l'appel",
    removing_all_participants_will_end_the_call: "La suppression de tous les participants mettra fin à l'appel.",
    are_you_sure_you_want_to_remove_from_this_call: "Êtes-vous sûr de vouloir supprimer <participantName> de cet appel ?",
    block_from_rejoining_this_call: "Empêcher <participantName> de rejoindre cet appel",
    turn_all_mics_off: "Désactiver tous les micros",
    turn_all_cams_off: "Désactiver toutes les caméras",
    ask_to_turn_mic_on: "Demander à allumer le micro",
    turn_mic_off: "Éteindre le micro",
    turn_cam_off: "Éteindre la caméra",
    ask_to_turn_cam_on: "Demander à allumer la caméra",
    ask_to_share_screen: "Demander à partager l'écran",
    having_a_video_problem: "Vous avez un problème vidéo ?",
    ios_play_pause_modal_body_text:
        "Essayez de désactiver le mode d'économie d'énergie de votre mobile pour résoudre ce problème ou veuillez cliquer sur le bouton Lecture ci-dessous pour lire la vidéo pour le moment.",
    play_video: "Lire la vidéo",
    camera_request_sent: "Demande de caméra envoyée.",
    waiting_for_host_approval: "En attente de l'approbation de l'hôte.",
    microphone_request_sent: "Demande de microphone envoyée.",
    camera_request_denied: "Demande de caméra refusée.",
    click_the_camera_icon_if_you_need_to_request_again: "Cliquez sur l'icône de l'appareil photo si vous devez effectuer une nouvelle demande.",
    microphone_request_denied: "Demande de microphone refusée.",
    click_the_mic_icon_if_you_need_to_request_again: "Cliquez sur l'icône du micro si vous devez faire une nouvelle demande.",
    deny: "Refuser",
    allow: "Permettre",
    user_wants_to_start_their_camera: "<ParticipantName> souhaite démarrer son <micOrCam>",
    error_in_processing_live_caption_please_retry: "Erreur lors du traitement des sous-titres en direct, veuillez réessayer.",
    virtual_background: "Arrière-plan virtuel",
    upload_image: "Télécharger l'image",
    remove_image: "Supprimer l'image",
    remove_background_image: "Supprimer l'image d'arrière-plan",
    are_you_sure_you_want_to_remove_background_image: "Êtes-vous sûr de vouloir supprimer l’image d’arrière-plan ?",
    unsupported_file_format: "Format de fichier non pris en charge.",
    the_maximum_file_size_supported_is_in_mb: "La taille de fichier maximale prise en charge est <size> Mo.",
    no_effect: "Aucun effet",
    blur_background: "Arrière-plan flou",
    default_image: "Image par défaut",
    virtual_background_not_supported: "Arrière-plan virtuel non pris en charge.",
    remove_from_call: "Supprimer de l'appel",
    enable_offline_mode: "Activer le mode hors ligne",
    offline_mode_enabled: "Mode hors ligne activé",
    your_images_will_upload_when_you_reconnect: "Vos images seront téléchargées lorsque vous vous reconnecterez.",
    please_keep_this_screen_open: "Veuillez garder cet écran ouvert.",
    max_images_upload: "Max <count> images",
    remaining_image_count_label: "<remainingCount> de <totalCount> images",
    selected_images: "Images sélectionnées",
    offline_uploads_are_not_supported_in_private_mode: "Les téléchargements hors ligne ne sont pas pris en charge en mode privé.",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "Veuillez passer à un onglet de navigateur normal pour utiliser cette fonctionnalité.",
    guest_is_using_a_private_browser_window: "L'invité utilise une fenêtre de navigateur privée.",
    offline_upload_mode_is_not_supported_in_this_case: "Le mode de téléchargement hors ligne n'est pas pris en charge dans ce cas.",
    some_images_failed_to_upload_due_to_a_network_error: "Certaines images n'ont pas pu être téléchargées en raison d'une erreur réseau.",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode:
        "La fermeture de cette fenêtre modale supprimera toutes les images que vous avez sélectionnées en mode hors ligne.",
    live_captions_stopped: "Les sous-titres en direct sont arrêtés.",
    translate: "Traduire",
    auto_translate: "Traduction automatique",
    your_language: "Votre langue",
    translation_info_text: "Les messages des autres participants seront automatiquement traduits dans la langue que vous avez sélectionnée.",
    translating: "Traduction en cours...",
    show_original: "Afficher l'original",
    show_translation: "Afficher la traduction",
    translated: "Traduit",
    send_message_in: "Envoyer un message dans",
    audio_translation: "Traduire",
    audio_translation_setup: "Traduction Audio",
    they_speak: "Ils parlent",
    i_want_to_hear: "Je veux entendre",
    start_translation: "Démarrer la Traduction",
    stop_translation: "Arrêter la Traduction",
    starting_translation: "Démarrage de la traduction...",
    translation_started: "Traduction audio démarrée.",
    translation_stopped: "Traduction audio arrêtée.",
    translation_error: "Erreur de traduction. Veuillez réessayer.",
    translation_active: "Traduction active",
    voice_type: "Voix",
    voice_female: "Féminine",
    voice_male: "Masculine",
};

export default fr;
